import BaseComponent from "@js/components/base_component.jsx";
import QrCodeScanner from "@js/components/eui/two_factor_authentications/qr_code_scanner.jsx";

class EuiTwoFactorAuthenticationsForm extends BaseComponent {

  static defaultProps = {
    editing: true,
  };

  render() {
    const email = ( this.props.library.current_user && this.props.library.current_user.email ) ? (
      this.props.library.current_user.email
    ) : (
      null
    );

    const otpSecret = ( email && this.props.entity.new_otp_secret ) ? (
      this.props.entity.new_otp_secret
    ) : (
      null
    );

    return (

      <div>

        <ErrorBanner entity={ this.props.entity } />

        <Panel heading="twofactor_setup_app">

          <p>
            { t("twofactor.setup_app_intro") }
          </p>

          <ul>
            {
              t("twofactor.setup_app_examples").map((example, ii) => (
                <li key={ ii }>{ example }</li>
              ))
            }
          </ul>

        </Panel>

        <Panel heading="twofactor_verify_password">

          <p>
            { t("twofactor.verify_current_password_intro") }
          </p>

          <hr />

          <InputField
            object={ this.props.entity }
            type="two_factor_authentication_setup"
            field="current_password"
            password={ true }
            editing={ this.props.editing }
          />

        </Panel>

        <Panel heading="twofactor_scan_code">

          <QrCodeScanner
            otp_secret={ otpSecret }
            email={ email }
            hr="<hr />"
          />

          <input
            type="hidden"
            name="two_factor_authentication_setup[otp_secret]"
            value={ otpSecret }
          />

        </Panel>

        <Panel heading="twofactor_verify_code">

          <p>
            { t("twofactor.verify_code_from_app_intro") }
          </p>

          <hr />

          <InputField
            object={ this.props.entity }
            type="two_factor_authentication_setup"
            field="otp_confirmation"
            valueText="(not shown)"
            password={ false }
            editing={ this.props.editing }
          />

        </Panel>

      </div>

    );
  }

}

export default EuiTwoFactorAuthenticationsForm;
